/* tslint:disable */
/* eslint-disable */

/**
 * 401130000 = Deutsch (Deutsch)
 * 
 * 401130001 = Mehrsprachig (Mehrsprachig)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum GlobalEnumsAcePortalsprache {
 Deutsch = 401130000,
 Mehrsprachig = 401130001
}

marker([
    "Enum.GlobalEnumsAcePortalsprache.Deutsch",
    "Enum.GlobalEnumsAcePortalsprache.Mehrsprachig"
]);

export namespace GlobalEnumsAcePortalsprache
{
    class DataSets
    {
        static GlobalEnumsAcePortalspracheDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("Deutsch", 401130000, "Deutsch"),
            new EnumValue("Mehrsprachig", 401130001, "Mehrsprachig"),
        )
    }

    export function getAsDataset() {
        return DataSets.GlobalEnumsAcePortalspracheDataSet;
    }
}
